import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Text, Heading, Typography } from '@fiverr-private/typography';
import { SigningModeType, useIdentificationContext } from '@fiverr-private/identification_core';
import { appTranslate } from '../../i18n';
import { useExperiment } from '../../shared/hooks/useExperiment';
import { Experiments } from '../../shared/constants/experiments';
import { globalBigQueryReporter, globalGrafanaReporter, globalMixpanelReporter } from '../../events';
import { BLOCKED_ACTION_MOBILE_LABEL_MAP, TRANSLATION_KEYS } from './InitialStepTitle.contants';
import { NewBriefAndMatchTitle } from './NewBriefAndMatchTitle';

export const InitialStepTitle = () => {
    const { mode, setMode, blockedActionType, variant } = useIdentificationContext();
    const isSignUp = mode === 'sign_up';
    const isStandaloneOnboarding = variant === 'onboarding';

    const { inGroupB: inContextualIndentificationFlowExp } = useExperiment(
        Experiments.SPIDERS_CONTEXTUAL_IDENTIFICATION_FLOW
    );
    const { inGroupB: inCtxRegBriefAndMatchExp } = useExperiment(Experiments.SPIDERS_CTX_REG_BRIEF_AND_MATCH);

    const toggleMode = () => {
        const mode: SigningModeType = isSignUp ? 'sign_in' : 'sign_up';
        setMode(mode);
        globalGrafanaReporter.count('identification.%{platform}.initial.show');
        globalMixpanelReporter.send('Identification - Initial - Show');
        globalBigQueryReporter.send('identification.initial.show');
    };

    const renderMobileTitle = () => {
        if (inCtxRegBriefAndMatchExp && blockedActionType === 'new_brief_and_match') {
            return <NewBriefAndMatchTitle />;
        }
        if (inContextualIndentificationFlowExp && blockedActionType && blockedActionType !== 'new_brief_and_match') {
            return appTranslate(BLOCKED_ACTION_MOBILE_LABEL_MAP[mode][blockedActionType], {
                templates: {
                    pink: (text?: string) => (
                        <Typography as="span" color="pink_700">
                            {text}
                        </Typography>
                    ),
                    green: (text?: string) => (
                        <Typography as="span" color="green_700">
                            {text}
                        </Typography>
                    ),
                },
            });
        }
        if (variant === 'go' && isSignUp) {
            return appTranslate('steps.initial.variant_go.title_when_sign_up');
        }
        return appTranslate('steps.initial.mobile_title', {
            templates: {
                pink: (text?: string) => (
                    <Container as="span" color="pink_700">
                        {text}
                    </Container>
                ),
            },
        });
    };

    const getTranslations = () => {
        if (variant === 'go') return TRANSLATION_KEYS.go[mode];

        return TRANSLATION_KEYS.default[mode];
    };

    const { titleKey, subtitleKey } = getTranslations();

    return (
        <Stack direction="column" paddingBottom="10" paddingX="0" gap="2">
            <Heading size={{ default: 'h_xl', md: isStandaloneOnboarding ? 'h_lg' : 'h_md' }} fontWeight="bold">
                <Container display={{ default: 'block', md: 'none' }}>{renderMobileTitle()}</Container>
                <Container display={{ default: 'none', md: 'block' }}>{appTranslate(titleKey)}</Container>
            </Heading>
            <Container>
                <Text>
                    {appTranslate(subtitleKey, {
                        templates: {
                            toggleIntentionBtn: (text?: string) => (
                                <Typography as="span" decoration="underline" onClick={toggleMode} cursor="pointer">
                                    {text}
                                </Typography>
                            ),
                        },
                    })}
                </Text>
            </Container>
        </Stack>
    );
};
